import { useQuery } from 'react-query';
import { getData } from 'src/Utils';
import { useEffect, useRef } from 'react';
export var useTowerOptions = function (_a) {
    var buildingId = _a.buildingId, resetTowerSelect = _a.resetTowerSelect;
    var isFirstRender = useRef(true);
    useEffect(function () {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (resetTowerSelect) {
            resetTowerSelect();
        }
    }, [buildingId]);
    var _b = useQuery(['tower-options', buildingId], function () { return getData("/buildings/" + buildingId + "/towers"); }, {
        refetchOnWindowFocus: false,
        enabled: typeof buildingId === 'number',
    }), data = _b.data, isLoading = _b.isLoading;
    var towerOptions = [];
    if (data === null || data === void 0 ? void 0 : data.towers) {
        towerOptions = data.towers.map(function (tower) { return ({
            label: tower.name,
            value: tower.id,
        }); });
    }
    return { isLoading: isLoading, towerOptions: towerOptions };
};
